<template>
    <svg width="45" height="45" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="step-svg-path" d="M18.975 5.06659C18.6958 5.0719 18.4262 5.16931 18.2081 5.34367L12.4512 9.95018L6.80312 7.69146C6.61102 7.61472 6.40305 7.5862 6.19738 7.60838C5.99172 7.63055 5.79461 7.70276 5.62328 7.81868C5.45196 7.93461 5.31163 8.09073 5.21455 8.2734C5.11748 8.45607 5.06661 8.65973 5.06641 8.86659V30.3999C5.06641 31.7845 6.21519 32.9333 7.59974 32.9333H30.3997C31.7843 32.9333 32.9331 31.7845 32.9331 30.3999V6.33326C32.9329 6.1264 32.882 5.92273 32.7849 5.74006C32.6879 5.55739 32.5475 5.40128 32.3762 5.28535C32.2049 5.16943 32.0078 5.09722 31.8021 5.07504C31.5964 5.05286 31.3885 5.08139 31.1964 5.15813L25.3331 7.50344L19.4698 5.15813C19.3126 5.09483 19.1444 5.06371 18.975 5.06659ZM30.3997 16.2142V30.3999H7.59974V21.5333L12.6664 26.5999L18.9997 18.9999L25.3331 20.2666L30.3997 16.2142Z" fill="currentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGStepsTextures"
    }
</script>

<style scoped>

</style>
